import { MessageCircle, Mail, Phone } from 'lucide-react';
import { Logo } from '@/components/ui/custom';

export interface FooterProps {
  onComoFuncionaClick: () => void;
  onEncontrarProfissionaisClick: () => void;
  onSouPsicologoClick: () => void;
  onPerguntasFrequentesClick: () => void;
}

export function Footer({
  onComoFuncionaClick,
  onEncontrarProfissionaisClick,
  onSouPsicologoClick,
  onPerguntasFrequentesClick,
}: FooterProps) {
  return (
    <footer className="border-t border-slate-700/90 bg-slate-800 px-3 py-8 text-slate-50 sm:px-6 sm:py-10 safe-area-px">
      <div className="mx-auto w-full min-w-0 max-w-6xl">
        <div className="mb-6 grid gap-6 sm:grid-cols-2 sm:gap-8 md:grid-cols-3">
          <div>
            <Logo variant="white" size="md" className="mb-4" />
            <p className="text-sm leading-relaxed text-slate-300">
              A Kuiva é uma plataforma angolana que liga pessoas a profissionais de saúde mental de
              forma simples, segura e acessível.
            </p>
          </div>

          <div>
            <h4 className="mb-4 font-semibold text-white">Links rápidos</h4>
            <ul className="space-y-2">
              <li>
                <button
                  type="button"
                  onClick={onComoFuncionaClick}
                  className="text-left text-sm text-slate-300 transition-colors hover:text-white"
                >
                  Como funciona
                </button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={onEncontrarProfissionaisClick}
                  className="text-left text-sm text-slate-300 transition-colors hover:text-white"
                >
                  Encontrar profissionais
                </button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={onSouPsicologoClick}
                  className="text-left text-sm text-slate-300 transition-colors hover:text-white"
                >
                  Sou psicólogo
                </button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={onPerguntasFrequentesClick}
                  className="text-left text-sm text-slate-300 transition-colors hover:text-white"
                >
                  Perguntas frequentes
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="mb-4 font-semibold text-white">Contacto</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="https://wa.me/244900000000"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-sm text-slate-300 transition-colors hover:text-white"
                >
                  <MessageCircle className="h-4 w-4 shrink-0 text-slate-400" />
                  WhatsApp
                </a>
              </li>
              <li>
                <a
                  href="mailto:ola@kuiva.ao"
                  className="flex items-center gap-2 text-sm text-slate-300 transition-colors hover:text-white"
                >
                  <Mail className="h-4 w-4 shrink-0 text-slate-400" />
                  ola@kuiva.ao
                </a>
              </li>
              <li>
                <a
                  href="tel:+244900000000"
                  className="flex items-center gap-2 text-sm text-slate-300 transition-colors hover:text-white"
                >
                  <Phone className="h-4 w-4 shrink-0 text-slate-400" />
                  +244 900 000 000
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-700/90 pt-6 text-center sm:pt-7">
          <p className="text-sm text-slate-300">
            Obrigado{' '}
            <span className="font-medium text-white">Paula Rafaela</span> por nos lembrares, todos os dias, o verdadeiro significado de ser humano.
          </p>
          <p className="mt-3 text-sm text-slate-400">
            © {new Date().getFullYear()} Kuiva. Todos os direitos reservados.
          </p>
          <p className="mt-2 text-xs text-slate-500">Feito com 💚 em Angola</p>
        </div>
      </div>
    </footer>
  );
}
